import api from './api';

export const fetchReferralOrders = async (params = {}) => {
  const response = await api.get('/referrals/admin/orders', { params });
  return response.data;
};
